import React, { useEffect, useRef, useState } from 'react'
import KeyboardIcon from '@mui/icons-material/Keyboard';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import CancelIcon from '@mui/icons-material/Cancel';

function IframeContent({ title, url, btnTypeG, setbtnTypeG, MessageItems, hideIframe, indexLength, arrayLength,scrollToBottom,openMic }) {
    const [show, setShow] = useState(false)
    const [loader, setLoader] = useState(false)
    
    const [btnType, setbtnType] = useState("footer")
    const [showBtn, setShowBtn] = useState(true)
    useEffect(() => {
        setShow(false)
    }, [hideIframe])

    useEffect(() => {
        // console.log(arrayLength +"Arraylength  - " + indexLength+ "IndexLength")
        if ((parseInt(arrayLength?.length - 2) > indexLength)) {
            setShowBtn(false)
            setShow(false)
        }
    }, [arrayLength])
    const scrollPage =()=>{
        setTimeout(() => {
            scrollToBottom()
        }, 400);
    }
    return (
        <>
            {
                showBtn ?
                    <>
                        {
                            btnTypeG === "chat" ?
                                <button type="button" className="btn-outline mb-8" onClick={() => { setShow(true); setShowBtn(false); setLoader(true) }}>{title}</button>
                                :
                                <>
                                    {
                                        btnType === "footer" ?
                                            <div className="appointment-footer-wrapper">
                                                {
                                                    openMic ?
                                                        <KeyboardVoiceIcon onClick={() => { setbtnType("chat"); setbtnTypeG("chat");scrollPage() }} />
                                                    :
                                                        <KeyboardIcon onClick={() => { setbtnType("chat"); setbtnTypeG("chat");scrollPage() }} />       
                                                }
                                                <button type="button" className="btn-default btn-seprate" onClick={() => { setShow(true); setShowBtn(false); setLoader(true) }}>{title}</button>
                                            </div>
                                            :
                                            <button type="button" className="btn-outline mb-8" onClick={() => { setShow(true); setShowBtn(false); setLoader(true) }}>{title}</button>
                                    }
                                </>
                        }
                    </>
                    :
                    <button type="button" className="btn-outline mb-8 btn-disabled" disabled onClick={() => { setShow(true); setShowBtn(false) }}>{title}</button>
            }
            <div className='iframe-wrapper'>
                <iframe className={`chat-iframe-page ${show ? "show-iframe" : ""}`} src={url.replace("<%session%>", `${MessageItems?.conversationId?.sessionToken+"--web--"+MessageItems?.groupId?.Id}`)} title="login page"></iframe>
                {
                    show && <CancelIcon className='close-iframe' onClick={() => { setShow(false); setShowBtn(true) }} />
                }
                {
                    loader ?
                        // <div className='iframe-skeleton placeholder-glow'>
                        //     <div className='iframe-body'>
                        //         <div className='placeholder img-load-block'></div>
                        //         <span class="placeholder w-90"></span>
                        //         <span class="placeholder w-70"></span>
                        //         <span class="placeholder w-60"></span>
                        //         <span class="placeholder w-50"></span>
                        //         <span class="placeholder w-60"></span>
                        //         <span class="placeholder w-50"></span>
                        //         <span class="placeholder w-70"></span>
                        //         <div class='btn-loader-sk placeholder'></div>
                        //     </div>
                        // </div>
                        <></>
                        :
                        <></>
                }
            </div>
        </>
    )
}
export default IframeContent
